"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const ShoppingCartIcon = props => _react.default.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.2963 11.97C17.9563 12.59 17.2963 13 16.5463 13H9.09629L7.99629 15H19.9963V17H7.99629C6.47629 17 5.51629 15.37 6.24629 14.03L7.59629 11.59L3.99629 4H1.99629V2H5.26629L6.20629 4H21.0063C21.7663 4 22.2463 4.82 21.8763 5.48L18.2963 11.97ZM19.3063 6H7.15629L9.52629 11H16.5463L19.3063 6ZM7.99629 18C6.89629 18 6.00629 18.9 6.00629 20C6.00629 21.1 6.89629 22 7.99629 22C9.09629 22 9.99629 21.1 9.99629 20C9.99629 18.9 9.09629 18 7.99629 18ZM16.0063 20C16.0063 18.9 16.8963 18 17.9963 18C19.0963 18 19.9963 18.9 19.9963 20C19.9963 21.1 19.0963 22 17.9963 22C16.8963 22 16.0063 21.1 16.0063 20Z",
  fill: "currentColor"
}));

var _default = ShoppingCartIcon;
exports.default = _default;